import { Route } from "react-router-dom";
import { lazy } from "react";
import {
  URL_2024_FANDAY_IN_BKK_PROJECT,
  URL_2025_BB_FANFEST_PROJECT,
  URL_2025_MILK_BD_PROJECT,
  URL_2025_STARLYMPICS_PROJECT,
  URL_2026_GIRLRULES_PROJECT,
  URL_2026_LOVEMUVBD_PROJECT,
  URL_2026_BBFANFEST_PROJECT
} from "../constant/URL";

const DonationFanday2024Form = lazy(
  () => import("../pages/project/01_project_fanday_2024/donation_form"),
);
const DonationFanday2024FormResponse = lazy(
  () =>
    import("../pages/project/01_project_fanday_2024/donation_form_response"),
);
const DonationBBFanFest2025Form = lazy(
  () => import("../pages/project/02_project_bb_fanfest_2025/donation_form"),
);
const DonationBBFanFest2025FormResponse = lazy(
  () =>
    import("../pages/project/02_project_bb_fanfest_2025/donation_form_response"),
);
const DonationMilkBD2025Form = lazy(
  () => import("../pages/project/03_project_milk_bd_2025/donation_form"),
);
const DonationMilkBD2025FormResponse = lazy(
  () =>
    import("../pages/project/03_project_milk_bd_2025/donation_form_response"),
);
const DonationStarlympics2025Form = lazy(
  () => import("../pages/project/04_project_starlympics_2025/donation_form"),
);
const DonationStarlympics2025FormResponse = lazy(
  () =>
    import("../pages/project/04_project_starlympics_2025/donation_form_response"),
);
const DonationGirlRules2026Form = lazy(
  () => import("../pages/project/05_project_girlrules_2026/donation_form"),
);
const DonationGirlRules2026FormResponse = lazy(
  () =>
    import("../pages/project/05_project_girlrules_2026/donation_form_response"),
);
const DonationLoveMuvBD2026Form = lazy(
  () => import("../pages/project/06_project_lovemuvbd_2026/donation_form"),
);
const DonationLoveMuvBD2026FormResponse = lazy(
  () =>
    import("../pages/project/06_project_lovemuvbd_2026/donation_form_response"),
);
const DonationBBFanFest2026Form = lazy(
  () => import("../pages/project/07_project_bbfanfest_2026/donation_form"),
);
const DonationBBFanFest2026FormResponse = lazy(
  () =>
    import("../pages/project/07_project_bbfanfest_2026/donation_form_response"),
);

export const ProjectRoutes = (
  <>
    <Route
      path={`project/${URL_2024_FANDAY_IN_BKK_PROJECT}/donation-form`}
      element={
        <DonationFanday2024Form endpoint={URL_2024_FANDAY_IN_BKK_PROJECT} />
      }
    />
    <Route
      path={`project/${URL_2024_FANDAY_IN_BKK_PROJECT}/donation-form-success`}
      element={<DonationFanday2024FormResponse isOK={true} />}
    />
    <Route
      path={`project/${URL_2024_FANDAY_IN_BKK_PROJECT}/donation-form-fail`}
      element={<DonationFanday2024FormResponse isOK={false} />}
    />
    <Route
      path={`project/${URL_2025_BB_FANFEST_PROJECT}/donation-form`}
      element={
        <DonationBBFanFest2025Form endpoint={URL_2025_BB_FANFEST_PROJECT} />
      }
    />
    <Route
      path={`project/${URL_2025_BB_FANFEST_PROJECT}/donation-form-success`}
      element={<DonationBBFanFest2025FormResponse isOK={true} />}
    />
    <Route
      path={`project/${URL_2025_BB_FANFEST_PROJECT}/donation-form-fail`}
      element={<DonationBBFanFest2025FormResponse isOK={false} />}
    />
    <Route
      path={`project/${URL_2025_MILK_BD_PROJECT}/donation-form`}
      element={<DonationMilkBD2025Form endpoint={URL_2025_MILK_BD_PROJECT} />}
    />
    <Route
      path={`project/${URL_2025_MILK_BD_PROJECT}/donation-form-success`}
      element={<DonationMilkBD2025FormResponse isOK={true} />}
    />
    <Route
      path={`project/${URL_2025_MILK_BD_PROJECT}/donation-form-fail`}
      element={<DonationMilkBD2025FormResponse isOK={false} />}
    />
    <Route
      path={`project/${URL_2025_STARLYMPICS_PROJECT}/donation-form`}
      element={
        <DonationStarlympics2025Form endpoint={URL_2025_STARLYMPICS_PROJECT} />
      }
    />
    <Route
      path={`project/${URL_2025_STARLYMPICS_PROJECT}/donation-form-success`}
      element={<DonationStarlympics2025FormResponse isOK={true} />}
    />
    <Route
      path={`project/${URL_2025_STARLYMPICS_PROJECT}/donation-form-fail`}
      element={<DonationStarlympics2025FormResponse isOK={false} />}
    />
    <Route
      path={`project/${URL_2026_GIRLRULES_PROJECT}/donation-form`}
      element={
        <DonationGirlRules2026Form endpoint={URL_2026_GIRLRULES_PROJECT} />
      }
    />
    <Route
      path={`project/${URL_2026_GIRLRULES_PROJECT}/donation-form-success`}
      element={<DonationGirlRules2026FormResponse isOK={true} />}
    />
    <Route
      path={`project/${URL_2026_GIRLRULES_PROJECT}/donation-form-fail`}
      element={<DonationGirlRules2026FormResponse isOK={false} />}
    />
    <Route
      path={`project/${URL_2026_LOVEMUVBD_PROJECT}/donation-form`}
      element={
        <DonationLoveMuvBD2026Form endpoint={URL_2026_LOVEMUVBD_PROJECT} />
      }
    />
    <Route
      path={`project/${URL_2026_LOVEMUVBD_PROJECT}/donation-form-success`}
      element={<DonationLoveMuvBD2026FormResponse isOK={true} />}
    />
    <Route
      path={`project/${URL_2026_LOVEMUVBD_PROJECT}/donation-form-fail`}
      element={<DonationLoveMuvBD2026FormResponse isOK={false} />}
    />
    <Route
      path={`project/${URL_2026_BBFANFEST_PROJECT}/donation-form`}
      element={
        <DonationBBFanFest2026Form endpoint={URL_2026_BBFANFEST_PROJECT} />
      }
    />
    <Route
      path={`project/${URL_2026_BBFANFEST_PROJECT}/donation-form-success`}
      element={<DonationBBFanFest2026FormResponse isOK={true} />}
    />
    <Route
      path={`project/${URL_2026_BBFANFEST_PROJECT}/donation-form-fail`}
      element={<DonationBBFanFest2026FormResponse isOK={false} />}
    />
  </>
);
